<template>
    <div class="mainDiv">

        <div class="botaoNovo">
            <div class="centerx default-input flex flex-wrap">
                <router-link :to="{name: 'event-form'}">
                    <vs-button class="ml-3" color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle">{{$t('newo')}}</vs-button>
                </router-link>
            </div>
        </div>
        
        <div>
            <vs-table max-items="15" pagination search stripe :data="event_list">
                <template slot="thead">
                    <vs-th>
                        {{$t('nome')}}
                    </vs-th>
                    <vs-th>
                        {{$t('Data_Inicio')}}
                    </vs-th>
                    <vs-th>
                        {{$t('Data_Fim')}}
                    </vs-th>
                    <vs-th>
                        {{$t('Categoria')}}
                    </vs-th>
                    <vs-th>
                    </vs-th>
                    <vs-th>
                    </vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(news_item, index) in data">
                        <vs-td>
                            {{news_item.name}}
                        </vs-td>
                        <vs-td>
                            {{news_item.start_date}}
                        </vs-td>
                        <vs-td>
                            {{news_item.end_date}}
                        </vs-td>
                        <vs-td>
                            <vs-chip :color="news_item.category.color">{{news_item.category.name}}</vs-chip>
                        </vs-td>
                        <vs-td>
                            <vs-button class="ml-3" color="primary" type="filled" icon-pack="feather" icon="icon-edit" @click="editEvent(news_item.event_id)"></vs-button>
                        </vs-td>
                        <vs-td>
                            <vs-button class="ml-3" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" @click="openDialog(news_item.event_id, news_item.name)"></vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>

    </div>
</template>

<script>
    
    export default {
        data(){
            return {
                event_list: []
            };
        },
        methods: {
            getList() {
                this.$vs.loading();
                this.$api({
                    method: 'get',
                    url: '/myvilagale/event/getList',
                    params: {
                        token: localStorage.getItem('usertoken'),
                    },
                })
                .then((res) => {
                    this.$vs.loading.close();
                    this.event_list = res.data;
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },
            editEvent(event_id){
                this.$router.push({name: 'event-form', params: { id: event_id }});
            },
            deleteEvent(event_id){
                this.$vs.loading();
                this.$api.post( '/myvilagale/event/deleteEvent?token=' + localStorage.getItem('usertoken'),
                {
                    event_id: event_id[0]
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                    }
                })
                .then((res) => {
                    this.$vs.loading.close();
                    this.notify(this.$t('Evento_apagado'), 'green');
                    this.getList();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },
            openDialog(event_id, name){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'primary',
                    title: this.$t('Deseja_mesmo_apagar_o_evento'),
                    text: this.$t('O_evento_será_apagado_e_não_será_possível_recuperá_lo', {'name': name}),
                    acceptText: this.$t('Apagar'),
                    cancelText: this.$t('cancels'),
                    accept: this.deleteEvent,
                    parameters: [event_id]
                });
            },
        },
        created(){
            this.getList();
        }
    }
</script>

<style>
    .botaoNovo {
        position: absolute;
        margin-top: 10px;
    }
    .mainDiv .con-pagination-table.vs-table--pagination .vs-row{
        display: flex !important;
        justify-content: flex-end !important;
    }
    .editButton{
        padding: 2px;
    }
</style>

